import { useContext, useEffect, useRef, useState } from "react";
import Radio from "../../../Form/Radio";
import ToastContext from "../../../../contexts/toast";
import { RichiestaService } from "../../../../services/RichiestaService";
import { useParams } from "react-router-dom";
import { FormUtility } from '../../../Utility/FormUtility';

const Step2 = (props) => {
  const richiesta = props.richiesta;
  const afterSubmitFunction = props.afterSubmitFunction;
  const previousBtnFunction = props.previousBtnFunction;
  const nextBtnFunction = props.nextBtnFunction;
  const formRef = useRef(null);
  const uploadRef = useRef(null);
  const [selectedRadio, setSelectedRadio] = useState(null);
  //const [saveDisabled, setSaveDisabled] = useState(true);
  const toastContext = useContext(ToastContext);
  const { id: richiestaId } = useParams();
  const [dirty, setDirty] = useState(false);
  const [inputErrors, setInputErrors] = useState([]);
  const [inSave, setInSave] = useState(false);

  const richiestaService = new RichiestaService();

  const utility = new FormUtility();
  useEffect(() => {
    const data = richiesta.richiestaRapportoBeneficiario;
    if (data && data.tipoRichiedente) {
      //edit
      setSelectedRadio(data.tipoRichiedente);
    }

    // if (
    //   data &&
    //   data.tipoRichiedente
    // ) {
    //   setSaveDisabled(false);
    // }

  }, [richiesta]);

  useEffect(() => {
    if (dirty) {
      props.onChangedValue();
    }
  }, [dirty]);

  const onNextBtnClick = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (nextBtnFunction) nextBtnFunction();
  };

  const onPrevBtnClick = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (nextBtnFunction) previousBtnFunction();
  };

  const handleRadioChange = (event) => {
    setDirty(true);
    setSelectedRadio(event.target.id);
    setFormErrors(false);
    setInputErrors([]);
    // if (event.target.id === "TUTORE_LEGALE") {
    //   setSaveDisabled(true);
    // } else {
      //setSaveDisabled(false);
    //}
    console.log("here");
  };

  const setFormErrors = (setFocus = true) => {
    const errors = utility.getAllInputErrors(formRef);
    setInputErrors(errors.map(el => el.id));
    if (setFocus && errors.length > 0) {
      errors[0].focus();
    }
  }

  const save = async (callBack) => {
    //TODO: se arrivo qui dal bottone avanti , dopo aver salvato devo eseguiore onNextBtnClick
    
    const tipoRichiedente = selectedRadio;
    await richiestaService.saveStep2(
      richiestaId,
      tipoRichiedente
    )
    .then((result)=>{
        richiesta.richiestaRapportoBeneficiario =
        result.richiestaRapportoBeneficiario;
      setDirty(false);
      if (uploadRef.current) uploadRef.current.reset();
      if (afterSubmitFunction) afterSubmitFunction(result);
      toastContext.success("Dati salvati", 6000);
      if (callBack)callBack();
      return true;
    })
    .catch((error) => {
        toastContext.error(utility.getErrorMsg(error), 12000);   
        return false;     
      });
    
  };

  const saveAndnext = async () => {
    console.log('saveandnext');
    if(!selectedRadio){
      setFormErrors();
      return;
    }
    if (dirty) {
      try {
        setInSave(true); // <-- IMPOSTA LO STATO DI SALVATAGGIO
        await save(() => onNextBtnClick(null));
      } finally {
        setInSave(false); // <-- RIPRISTINA STATO DOPO IL SALVATAGGIO
      }
      return false;
    }
  
    onNextBtnClick(null);
  };

  return (
    <div className=" rtds-my-12 ">
      <div className="rtds-mb-6">
        <h1 className="rtds-text-2xl rtds-font-bold">
          {"Rapporto col beneficiario"}
        </h1>
      </div>
      <div className="rtds-background-01 rtds-p-6 rtds-border rtds-border-gray-02">
        <div className="rtds-pb-6 rtds-space-y-4 rtds-border-b rtds-border-gray-02">
          <p>
            I campi obbligatori sono contrassegnati da un asterisco&nbsp;
            <abbr
              className="rtds-font-bold rtds-no-underline"
              title="obbligatorio"
            >
              *
            </abbr>
          </p>
        </div>

        <form
          noValidate
          ref={formRef}
          id="hasValidationFor"
          className="has-js-validation-form rtds-py-6 rtds-space-y-4"
        >
          <fieldset className="rtds-input-field rtds-gap-2">
            <legend className="rtds-input-field__label">
              {
                "Soggetto per il quale si presenta la domanda di partecipazione alla misura Libri Gratis di Regione Toscana"
              }
              <abbr
                className="rtds-font-bold rtds-no-underline"
                title="obbligatorio"
              >
                *
              </abbr>
            </legend>
            <Radio
              classDiv={"rtds-input-radio rtds-input--lg"}
              label={
                "Sono uno/a studente/studentessa maggiorenne e sto presentando domanda per me"
              }
              id={"STUDENTE_MAGGIORENNE"}
              checked={selectedRadio === "STUDENTE_MAGGIORENNE"}
              onChange={handleRadioChange}
              required
            ></Radio>

            <Radio
              classDiv={"rtds-input-radio rtds-input--lg"}
              label={"Sto presentando domanda per mio/a figlio/a"}
              id={"GENITORE"}
              checked={selectedRadio === "GENITORE"}
              onChange={handleRadioChange}
              required
            ></Radio>

            <Radio
              classDiv={"rtds-input-radio rtds-input--lg"}
              label={
                "Sto presentando domanda per uno/a studente/studentessa di cui sono tutore o legale rappresentante"
              }
              id={"TUTORE_LEGALE"}
              checked={selectedRadio === "TUTORE_LEGALE"}
              onChange={handleRadioChange}
              required
              inputErrors={inputErrors}
            ></Radio>
          </fieldset>

          <div className="rtds-border-gray-02 rtds-border-b rtds-border-t rtds-p-3 rtds-flex sm:justify-end justify-center">
            <div className="rtds-form-actions">
              <div
                className="rtds-inline-flex rtds-gap-1"
                role="group"
                aria-label="Azioni"
              >
                <button
                  onClick={onPrevBtnClick}
                  type="button"
                  className="rtds-btn rtds-btn--secondary rtds-btn--icon-left rtds-group/button rtds-form-submit"
                >
                  <svg
                    className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6  group-hover/button:-rtds-translate-x-1"
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-uturn-left`}
                    />
                  </svg>{" "}
                  Indietro
                </button>
                <button
                  type="button"
                  disabled={inSave}
                  aria-busy={inSave}
                  className="rtds-btn rtds-btn--primary rtds-form-submit rtds-btn--icon-right rtds-group/button"
                  onClick={saveAndnext}
                >
                    Salva<span className="lg:sx-diplay-none"> e vai avanti</span>
                    {inSave ? (
                                        <>
                                            <svg
                                                className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 rtds-animate-spin md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6"
                                                aria-hidden="true"
                                                focusable="false"
                                                role="img"
                                            >
                                                <use  xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`} />
                                            </svg>
                                            <span className="rtds-sr-only">Caricamento...</span>
                                            </>
                                    ) : (
                                        <>
                                            <svg
                                                className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:rtds-translate-x-1"
                                                aria-hidden="true"
                                                focusable="false"
                                                role="img"
                                            >
                                                <use
                                                xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-right`}
                                                />
                                            </svg>
                                        </>
                                    )}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Step2;
